module.exports = __webpack_public_path__ + "static/media/20ECE31.cb3ce67b.jpg";